var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileSetupBannerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9209_13006)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.6123 20.4911C40.6123 32.2058 30.5894 41.5921 18.6565 40.5371C8.16052 39.6093 0.375 30.3504 0.375 19.818V1.30015C0.375 0.790815 0.793381 0.390625 1.28452 0.390625H21.003C31.8628 0.663482 40.6123 9.55863 40.6123 20.5093V20.4911Z",
    stroke: "#1C1C1E",
    strokeWidth: 0.626911,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9579 27.1742C33.9579 30.7578 31.0656 33.6501 27.4821 33.6501C23.8987 33.6501 21.0063 30.7578 21.0063 27.1742C21.0063 30.7578 18.114 33.6501 14.5305 33.6501C10.947 33.6501 8.05469 30.7578 8.05469 27.1742C8.05469 23.5908 10.947 20.6985 14.5305 20.6985C14.967 20.6985 15.3854 20.6621 15.8039 20.5711C15.3854 20.4802 14.967 20.4438 14.5305 20.4438C10.947 20.4438 8.05469 17.5515 8.05469 13.968C8.05469 10.3845 10.947 7.49219 14.5305 7.49219C18.114 7.49219 21.0063 10.3845 21.0063 13.968C21.0063 10.3845 23.8987 7.49219 27.4821 7.49219C31.0656 7.49219 33.9579 10.3845 33.9579 13.968C33.9579 17.5515 31.0656 20.4438 27.4821 20.4438C27.0455 20.4438 26.6272 20.4802 26.2088 20.5711C26.6272 20.6621 27.0455 20.6985 27.4821 20.6985C31.0656 20.6985 33.9579 23.5908 33.9579 27.1742Z",
    stroke: "#1C1C1E",
    strokeWidth: 0.626911,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.6846 0.375H1.3027C0.790343 0.375 0.375 0.790353 0.375 1.30272V39.6846C0.375 40.197 0.790343 40.6123 1.3027 40.6123H39.6846C40.197 40.6123 40.6123 40.197 40.6123 39.6846V1.30272C40.6123 0.790353 40.197 0.375 39.6846 0.375Z",
    stroke: "#1C1C1E",
    strokeWidth: 0.626911,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0603 24.9643C23.4839 24.9643 25.4486 22.9995 25.4486 20.5759C25.4486 18.1522 23.4839 16.1875 21.0603 16.1875C18.6366 16.1875 16.6719 18.1522 16.6719 20.5759C16.6719 22.9995 18.6366 24.9643 21.0603 24.9643Z",
    fill: "#CDD7D6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9209_13006"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 41,
    height: 41,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileSetupBannerIcon);
export default __webpack_public_path__ + "static/media/profile-setup-banner-icon.6d0c84e9717687df6f02cddf2196f145.svg";
export { ForwardRef as ReactComponent };